export interface BreadcrumbItem {
    url?: string;
    title: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
    className?: string;
}

/**
 * DEPRECATED:
 * Use Breadcrumb components from '@finn-no/troika-react-breadcrumbs' or '@fabric-ds/react'
 **/
export const Breadcrumbs = ({ items, className }: BreadcrumbsProps) => {
    const renderItems = items.map((item) =>
        item.url ? (
            <li key={`breadcrumb-item-${item.url}`}>
                <a className="u-display-inline-block u-ma0 u-b1" href={item.url}>
                    {item.title}
                </a>
            </li>
        ) : (
            <li key={`breadcrumb-item-${item.title}`}>
                <span className="u-display-inline-block u-ma0 u-b1">{item.title}</span>
            </li>
        ),
    );

    return (
        <nav aria-label="Her er du" className={className} data-testid="breadcrumbs">
            <ul className="breadcrumbs u-ma0">{renderItems}</ul>
        </nav>
    );
};
